import { render, staticRenderFns } from "./Squiz.vue?vue&type=template&id=3e0bebee"
import script from "./Squiz.vue?vue&type=script&lang=js"
export * from "./Squiz.vue?vue&type=script&lang=js"
import style0 from "./Squiz.vue?vue&type=style&index=0&id=3e0bebee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports